import { render, staticRenderFns } from "./OrderHistoryReport.vue?vue&type=template&id=d6788bde&scoped=true&"
import script from "./OrderHistoryReport.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryReport.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryReport.vue?vue&type=style&index=0&id=d6788bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6788bde",
  null
  
)

export default component.exports